
export default function ServicesPreview() {
  const services = [
    {
      icon: 'ri-computer-line',
      title: 'Website Design & Development',
      description: 'Custom e-commerce and corporate websites that convert visitors into customers.',
      href: '/services#website-design'
    },
    {
      icon: 'ri-facebook-fill',
      title: 'Meta Ads',
      description: 'Facebook and Instagram advertising campaigns that drive targeted traffic and sales.',
      href: '/services#meta-ads'
    },
    {
      icon: 'ri-search-line',
      title: 'SEO',
      description: 'Search engine optimization to improve your organic visibility and rankings.',
      href: '/services#seo'
    },
    {
      icon: 'ri-google-fill',
      title: 'Google Ads',
      description: 'Search, display, shopping, and YouTube ads that maximize your ROI.',
      href: '/services#google-ads'
    },
    {
      icon: 'ri-share-line',
      title: 'Social Media Optimization',
      description: 'Complete social media strategy, setup, and growth optimization.',
      href: '/services#smo'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Performance Marketing',
      description: 'End-to-end ad strategy with conversion tracking and ROAS growth.',
      href: '/services#performance-marketing'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Core Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We offer comprehensive digital marketing solutions designed to accelerate your business growth and maximize your online presence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-4">
                {service.description}
              </p>
              <a 
                href={service.href}
                className="text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
              >
                Learn More →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
